module.exports = __webpack_public_path__ + "static/media/colicoli17.6973f0c7.webp";